import ActionManager from '../ActionManager';

import ChangeTab from './ChangeTab';
ActionManager.register(ChangeTab, ['stores:MainStore']);
